import { apiRequest } from "./api";

export type VehiclePayload = {
    school_id?: string | null;
    vehicle_number: string;
    model?: string | null;
    seating_capacity: number;
    driver_id?: string | null;
    helper_id?: string | null;
    contact_number?: string | null;
    insurance_expiry?: string | null;
    fitness_expiry?: string | null;
    is_active?: boolean;
}

export async function saveFleetInfo(payload: VehiclePayload) {
    const res = await apiRequest('/api/vehicles', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
    return res;
}

export async function updateFleetInfo(id: string, payload: VehiclePayload) {
    const res = await apiRequest(`/api/vehicles/${id}`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    });
    return res;
}

export interface StaffSummary {
    id: string;
    first_name: string;
    last_name: string;
}

export interface SchoolSummary {
    id: string;
    name?: string;
}

export interface Vehicle {
    id: string;
    organization_id: string;
    school_id: string | null;
    vehicle_number: string;
    model: string | null;
    seating_capacity: number;
    driver_id: string | null;
    helper_id: string | null;
    contact_number: string | null;
    insurance_expiry: string | null;
    fitness_expiry: string | null;
    is_active: boolean;
    created_at: string;
    updated_at: string;

    // Relationships (Loaded via Eloquent 'with')
    school: SchoolSummary | null;
    driver: StaffSummary | null;
    helper: StaffSummary | null;
};

export async function fetchVehicles(): Promise<Vehicle[]> {
    const res = await apiRequest<Vehicle[]>('/api/vehicles');
    console.log(res)
    return res.data;
}
